export default __webpack_public_path__ + "static/media/csulb_image1.9f469f61.jpg";